import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
import type { CountryCode } from '../utils/calculations';
import { getCountry } from '../utils/calculations';
interface DashboardHeaderProps {
  country?: CountryCode;
}
export function DashboardHeader({
  country
}: DashboardHeaderProps) {
  const countryName = country ? getCountry(country).name.toUpperCase() : null;
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="text-center space-y-4 py-8" data-id="element-83">
      <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-white/[0.05] border border-white/10 mb-4" data-id="element-84">
        <Activity className="w-4 h-4 text-salmon" data-id="element-85" />
        <span className="text-xs font-semibold tracking-widest text-salmon uppercase" data-id="element-86">
          Live Operation Status
        </span>
      </div>
      <div className="space-y-2" data-id="element-87">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-wide uppercase text-white drop-shadow-lg leading-none" data-id="element-88">
          Tablero Estratégico
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl font-light italic text-white/70 tracking-widest" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-89">
          by Lucas Torres
        </p>
      </div>
      <p className="text-lg md:text-xl text-salmon/80 max-w-2xl mx-auto font-medium" data-id="element-90">
        Monitorea la salud real de tu operación en tiempo real.
      </p>
    </motion.div>;
}